// import React from "react";
// import { Modal, Box, TextField, Button } from "@mui/material";
// import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
// import circleImage from "../assets/images/circleIcon.png"; // Path to your image

// const BankDetailModal = ({
//   open,
//   onClose,
//   fields,
//   handleSave, // Corrected
//   newRowData,
//   handleFieldChange, // Corrected
//   tabLabel,
// }) => {
//   console.log("Modal Fields:", fields); // Ensure fields are passed correctly
//   console.log("newRowData:", newRowData); // Log to see the newRowData state

//   return (
//     <Modal
//       open={open}
//       onClose={onClose}
//       className="fixed inset-0 z-50 flex items-center justify-center"
//     >
//       <Box className="bg-white w-full max-w-2xl relative">
//         {/* Custom Header with Circle Image */}
//         <div className="relative bg-[#CAE5FF] px-4 py-2 flex items-center justify-between border-b-4 border-[#3A8FF6] w-full">
//           <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-2 shadow-md">
//             <img src={circleImage} alt="Circle Icon" className="h-12 w-12" />
//           </div>
//           <div>
//             <span className="font-semibold">{tabLabel}</span>
//           </div>
//           <button
//             onClick={onClose}
//             className="text-secondary-600 hover:text-secondary-900"
//           >
//             <CloseOutlinedIcon />
//           </button>
//         </div>

//         {/* Modal Body: Dynamic Fields with Grid Layout */}
//         <div className="px-5 py-5">
//           {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 m-4">
//             {fields.map((field, index) => (
//               <TextField
//                 key={index}
//                 label={field.name}
//                 name={field.name}
//                 value={newRowData[field.name] || ""}
//                 onChange={handleFieldChange} // This ensures input updates
//                 fullWidth
//                 margin="dense"
//                 className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
//               />
//             ))}
//           </div> */}
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 m-4">
//             {fields.map((field) => (
//               <div key={field.name} className="col-1 mb-4">
//                 <div className="relative">
//                   <input
//                     id={field.name}
//                     type="text"
//                     name={field.name}
//                     value={newRowData[field.name] || ""}
//                     onChange={handleFieldChange}
//                     className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
//                     placeholder=""
//                   />
//                   <label
//                     htmlFor={field.name}
//                     className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
//                   >
//                     {field.name}
//                   </label>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Button Section */}
//           <div className="flex justify-end space-x-2 mt-4">
//             <Button
//               onClick={onClose}
//               variant="outlined"
//               color="secondary"
//               className="w-24"
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handleSave}
//               variant="contained"
//               color="primary"
//               className="w-24"
//             >
//               Save
//             </Button>
//           </div>
//         </div>
//       </Box>
//     </Modal>
//   );
// };

// export default BankDetailModal;

import React from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import circleImage from "../assets/images/circleIcon.png";

const BankDetailModal = ({
  open,
  onClose,
  fields,
  handleSave,
  newRowData,
  handleFieldChange,
  tabLabel,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center"
    >
      <Box className="bg-white w-full max-w-2xl relative">
        {/* Custom Header with Circle Image */}
        <div className="relative bg-[#CAE5FF] px-4 py-2 flex items-center justify-between border-b-4 border-[#3A8FF6] w-full">
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-2 shadow-md">
            <img src={circleImage} alt="Circle Icon" className="h-12 w-12" />
          </div>
          <div>
            <span className="font-semibold">{tabLabel}</span>
          </div>
          <button
            onClick={onClose}
            className="text-secondary-600 hover:text-secondary-900"
          >
            <CloseOutlinedIcon />
          </button>
        </div>

        {/* Modal Body: Dynamic Fields with Grid Layout */}
        <div className="px-5 py-5">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 m-4">
            {fields.map((field) => (
              <div key={field.name} className="col-1 mb-4">
                <div className="relative">
                  {field.type === "select" ? (
                    <FormControl fullWidth>
                      {/* <InputLabel>{field.name}</InputLabel> */}
                      <Select
                        name={field.name}
                        value={newRowData[field.name] || ""}
                        onChange={handleFieldChange}
                        onInput={(e) => {
                          if (field.name === "Area") {
                            e.target.value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                            handleFieldChange({
                              target: {
                                name: field.name,
                                value: e.target.value,
                              }, // Update state properly
                            });
                          }
                        }}
                        className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                        placeholder=""
                      >
                        {field.options.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    <input
                      id={field.name}
                      type="text"
                      name={field.name}
                      value={newRowData[field.name] || ""}
                      onChange={handleFieldChange}
                      className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                      placeholder=""
                    />
                  )}
                  <label
                    htmlFor={field.name}
                    className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                  >
                    {field.name}
                  </label>
                </div>
              </div>
            ))}
          </div>

          {/* Button Section */}
          <div className="flex justify-end space-x-2 mt-4">
            <Button
              onClick={onClose}
              variant="outlined"
              color="secondary"
              className="w-24"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              color="primary"
              className="w-24"
            >
              Save
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default BankDetailModal;
